import React from 'react';
import { BasketCard } from '../../BasketCard/BasketCard';
import GhostBasketCard from '../../GhostBasketCard';

const BasketGrid = ({
  baskets,
  selectedBasketId,
  onBasketSelect,
  currentBasketId,
  searchTerm,
  onBasketMenuClick,
  hasNoOtherBaskets = false,
  showFilterEmptyMessage = false,
  showGhostBasket = false,
  ghostBasketName = '',
  ghostBasketTopic = null,
  onGhostBasketCreate,
  isCreatingGhostBasket = false,
}) => {
  const trimmedSearch = searchTerm.trim();

  const renderEmptyState = () => {
    if (hasNoOtherBaskets && !trimmedSearch) {
      return (
        <>
          {currentBasketId ? (
            <p>No other baskets yet.</p>
          ) : null}
          <p>Name a new basket after this topic&apos;s hardest detail.</p>
          <p className="text-sm">
            Type it in the search bar to preview the new basket, then tap{' '}
            <span className="font-semibold text-gray-700 dark:text-gray-200">Create and place</span>.
          </p>
        </>
      );
    }

    if (trimmedSearch) {
      return (
        <>
          <p>Nothing called &quot;{trimmedSearch}&quot; yet.</p>
          <p className="text-sm">
            Keep typing to preview a new basket you can create in one tap.
          </p>
        </>
      );
    }

    if (showFilterEmptyMessage) {
      return <p>Nothing matches this filter.</p>;
    }

    return <p>No baskets available.</p>;
  };

  const showEmptyState = baskets.length === 0 && !showGhostBasket;

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 overflow-y-auto flex-grow">
      {showGhostBasket && ghostBasketTopic && (
        <GhostBasketCard
          name={ghostBasketName}
          topic={ghostBasketTopic}
          onCreate={onGhostBasketCreate}
          isCreating={isCreatingGhostBasket}
        />
      )}
      {baskets.map(basket => (
        <BasketCard
          key={basket.id || `temp-${Date.now()}`}
          basket={basket}
          onClick={() => onBasketSelect(basket.id)}
          onMenuClick={(basket, action) => onBasketMenuClick(basket, action)}
          searchTerm={searchTerm}
          isSelected={basket.id === selectedBasketId}
          isClickable={basket.id !== currentBasketId}
          isBSIComponent={true}
        />
      ))}
      {showEmptyState && (
        <div
          className="col-span-full text-center text-gray-500 dark:text-gray-400 py-8 space-y-2"
          role="status"
          aria-live="polite"
        >
          {renderEmptyState()}
        </div>
      )}
    </div>
  );
};

export default BasketGrid;
